import { SyntheticEvent } from 'react';
import { Col, Nav, NavItem, Row, TabContainer } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import PageHeader from 'components/pageHeader/PageHeader';
import { VerticalTabContainer } from 'components/tab/Tab.styles';
import useFeatures from 'hooks/useFeatures';
import { normalizeKey } from 'utils/localeUtils';
import { DirectBookingEngineContainer } from './DirectBookingEngine.styles';
import {
  DirectBookingEngineTab,
  DirectBookingEngineTabType,
} from './DirectBookingEngineTabs.constants';
import useDirectBookingEngineActiveTab from './useDirectBookingEngineActiveTab';

const tabHeaders: Record<
  DirectBookingEngineTabType,
  { title: string; subtitle?: string }
> = {
  [DirectBookingEngineTab.websiteSettings]: {
    title: 'pageDirectBookingEngine.pageTitle',
  },
  [DirectBookingEngineTab.customDomain]: {
    title: 'pageDirectBookingEngine.whiteLabelSettings.pageTitle',
    subtitle: 'pageDirectBookingEngine.whiteLabelSettings.pageSubtitle',
  },
};

export const DirectBookingEngineDefaultRoute = () => (
  <Navigate to={DirectBookingEngineTab.websiteSettings} replace />
);

const DirectBookingEngine = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { allowDbsSettingsV3 } = useFeatures();
  const activeTab = useDirectBookingEngineActiveTab();

  if (!allowDbsSettingsV3) {
    return <Navigate to="/agency-settings" replace />;
  }

  const onSelect = (event: SyntheticEvent<TabContainer, Event>) => {
    const tabName = event as unknown as string; // should be fixed by BS5

    navigate(tabName);
  };

  const { title, subtitle } = tabHeaders[activeTab];

  return (
    <DirectBookingEngineContainer
      className="container"
      data-testid="direct-booking-engine"
    >
      <VerticalTabContainer activeKey={activeTab} onSelect={onSelect}>
        <Row>
          <Col sm={3}>
            <Nav stacked>
              {Object.values(DirectBookingEngineTab).map((tab) => (
                <NavItem
                  data-testid={`direct-booking-engine-tab-${tab}`}
                  eventKey={tab}
                  key={tab}
                >
                  {t(normalizeKey(`pageDirectBookingEngine.tabNames.${tab}`))}
                </NavItem>
              ))}
            </Nav>
          </Col>
          <Col sm={9}>
            <PageHeader
              noDivider
              subtitle={subtitle && t(normalizeKey(subtitle))}
              title={t(normalizeKey(title))}
            />
            <Outlet />
          </Col>
        </Row>
      </VerticalTabContainer>
    </DirectBookingEngineContainer>
  );
};

export default DirectBookingEngine;
